// src/components/MainApp.js
//エラー残っています
import React, { useState,useEffect} from 'react';
import { useLocation } from 'react-router-dom';  // location情報を取得するフック
import ModelViewer from "../ModelViewer";
import DrawingViewer from "../DrawingViewer";
import DrawingPrepare from "../DrawingPrepare";
import ToHomeButton from "../buttons/ToHomeButton";
import NavigateButton from "../buttons/NavigateButton";
import ModelSelecter from "../buttons/ModelSelecter";

function Demo4() {
  const location = useLocation();
  const errorScore = location.state?.errorScore;  // 渡されたerrorScoreを取得
  const defaultGlbPath = errorScore ? `model${errorScore}` : "model1";
  const [errorGlbPath, setErrorGlbPath] = useState(defaultGlbPath);
  const [drawingImages, setDrawingImages] = useState([null, null, null]);
  const [imagesLoading, setImagesLoading] = useState(true);
  const handleImagesReady = (images) => {
    console.log('[Demo4] handleImagesReady called with:', images);
    setDrawingImages(images);
    setImagesLoading(false);
  };
  const [motifGlbPath, setMotifGlbPath] = useState(() => (defaultGlbPath && defaultGlbPath.startsWith("cube") ? "cube" : "model"));

  useEffect(() => {
    if (errorGlbPath && errorGlbPath.startsWith("cube")) setMotifGlbPath("cube");
    else setMotifGlbPath("model");
  }, [errorGlbPath]);

  // モデルが選択された時に画像ローディング状態をリセット（新たに画像を準備させる）
  useEffect(() => {
    setImagesLoading(true);
  }, [errorGlbPath]);

  // 状態変化をログ出力（デバッグ用）
  useEffect(() => {
    console.log('[Demo4] State update:', { imagesLoading, drawingImagesLength: drawingImages.length, drawingImages });
  }, [imagesLoading, drawingImages]);

  return (
    <div className="page">
      <h1 className="heading-hero mb-6">DEMO4</h1>
      {/* 画像準備（隠しキャンバスでレンダリングしてバックエンド処理）。
          key でモデル切替時に再マウントする（Ex1_2026_Shape と同じ方式）。
          据え置きで errorGlbPath だけ差し替えると、モチーフ側レンダラー（glbPath 不変）の
          ready 監視が再発火せず、画像準備が永久に完了しない。 */}
      <DrawingPrepare key={errorGlbPath} errorGlbPath={errorGlbPath} onImagesReady={handleImagesReady} />

      <div className="w-full flex flex-row gap-4">
        <div className="w-1/2 flex flex-col items-center">
          <h2 className="heading-lg mb-2">モチーフ</h2>
          <h3 className="text-subtitle mb-1">元のモチーフ</h3>
          {imagesLoading ? (
            <div className="w-full h-48 flex items-center justify-center">
              <p>画像を準備しています...</p>
            </div>
          ) : (
            <>
              {console.log('[Demo4] About to render leftDrawingCanvas with drawingImages[2]:', drawingImages[2])}
              <DrawingViewer
                glbPath={motifGlbPath}
                caption="左"
                canvasId="leftDrawingCanvas"
                initialImageUrl={drawingImages[2]}
              />
            </>
          )}
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={motifGlbPath}
            imagePath={`./drawing/${motifGlbPath}.png`}
            caption="左"
            canvasId="leftModelCanvas"
          />
        </div>

        <div className="w-1/2 flex flex-col items-center">
          <h2 className="heading-lg mb-2">誤り</h2>
          <h3 className="text-subtitle mb-1">あなたのデッサン</h3>
          {imagesLoading ? (
            <div className="w-full h-48 flex items-center justify-center">
              <p>画像を準備しています...</p>
            </div>
          ) : (
            <>
              {console.log('[Demo4] About to render rightDrawingCanvas with drawingImages[0]:', drawingImages[0])}
              <DrawingViewer
                glbPath={errorGlbPath}
                caption="右"
                canvasId="rightDrawingCanvas"
                initialImageUrl={drawingImages[0]}
              />
            </>
          )}
          <h3 className="text-subtitle mt-3 mb-1">3Dモデル</h3>
          <ModelViewer
            glbPath={errorGlbPath}
            imagePath="./drawing/model1.png"
            caption="右"
            canvasId="rightModelCanvas"
          />
        </div>
      </div>

      <div className="row-center mt-6">
        <ModelSelecter
          errorGlbPath={errorGlbPath}
          setErrorGlbPath={setErrorGlbPath}
        />
      </div>

      <div className="row-center mt-6">
        <ToHomeButton buttonText="Home画面に戻る" />
        <NavigateButton to="/correction" buttonText="誤りに気が付いた" className="btn--danger" />
        <NavigateButton to="/suggest" buttonText="修正過程を見る" className="btn--secondary" />
        <NavigateButton to="/suggest2" buttonText="修正過程を少しずつ見る" state={{ errorScore }} className="btn--secondary" />
      </div>
    </div>
  );
}

export default Demo4;
